export const PLURAL_UNITS = {
  MFC: 'MFC',
};

const createPluralFormatter = ({ few, one, two }) => {
  const titles = [one, two, few];

  return number => {
    const cases = [2, 0, 1, 1, 1, 2];
    const absoluteValue = Math.abs(number);

    return titles[
      absoluteValue % 100 > 4 && absoluteValue % 100 < 20
        ? 2
        : cases[absoluteValue % 10 < 5 ? absoluteValue % 10 : 5]
    ];
  };
};

const pluralFormatters = {
  [PLURAL_UNITS.MFC]: createPluralFormatter({
    few: 'центрах',
    one: 'центре',
    two: 'центрах',
  }),
};

const pluralize = (value, unit) => pluralFormatters[unit](value);

export default pluralize;
